import {
  WorkflowContainerCheckPointI,
  WorkflowContainerCheckPointActionI,
} from "../../../libs/interfaces";
import { StateCreator } from "zustand";
import { removeImageBlob, saveImageBlob } from "../../../libs/helpers";

export const createWorkflowCheckpointSlice: StateCreator<
  WorkflowContainerCheckPointI & WorkflowContainerCheckPointActionI,
  [],
  []
> = (set, get) => ({
  activeKey: ["1"],
  setActiveKey: (activeKey) => set(() => ({ activeKey })),

  id: null,
  container: "",
  statusCP: 0,

  siglasPhoto: "",
  adhesivoPhoto: "",
  cableVerificadoraPhoto: "",
  botellaVerificadoraRastreoPhoto: "",
  numRastreoSatelitalPhoto: "",
  adhesivoPuertaPhoto: "",
  adhesivoBisagraPhoto1: "",
  adhesivoBisagraPhoto2: "",
  adhesivoBisagraPhoto3: "",
  cableExporPhoto: "",
  botellaExporPhoto: "",
  botellaNavieraPhoto: "",
  ventoleraDerechaPhoto: "",
  ventoleraIzquierdaPhoto: "",
  panelIzquierdoPhoto: "",
  panelDerechoPhoto: "",
  panelExteriorRePhoto1: "",
  panelExteriorRePhoto2: "",
  panelExteriorRePhoto3: "",
  inspectionContainerPhoto: "",
  observation: "",

  siglasCheckPhoto: "",
  adhesivoCheckPhoto: "",
  cableVerificadoraCheckPhoto: "",
  botellaVerificadoraRastreoCheckPhoto: "",
  numRastreoSatelitalCheckPhoto: "",
  adhesivoPuertaCheckPhoto: "",
  adhesivoBisagraCheckPhoto1: "",
  adhesivoBisagraCheckPhoto2: "",
  adhesivoBisagraCheckPhoto3: "",
  cableExporCheckPhoto: "",
  botellaExporCheckPhoto: "",
  botellaNavieraCheckPhoto: "",
  ventoleraDerechaCheckPhoto: "",
  ventoleraIzquierdaCheckPhoto: "",
  panelIzquierdoCheckPhoto: "",
  panelDerechoCheckPhoto: "",

  setId: (id) => set(() => ({ id })),
  setContainer: (container) => set(() => ({ container })),
  setSiglasPhoto: async (file) => {
    const getImageBack = get().siglasPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ siglasPhoto: photoId }));
  },
  setAdhesivoPhoto: async (file) => {
    const getImageBack = get().adhesivoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ adhesivoPhoto: photoId }));
  },
  setCableVerificadoraPhoto: async (file) => {
    const getImageBack = get().cableVerificadoraPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ cableVerificadoraPhoto: photoId }));
  },
  setBotellaVerificadoraRastreoPhoto: async (file) => {
    const getImageBack = get().botellaVerificadoraRastreoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ botellaVerificadoraRastreoPhoto: photoId }));
  },
  setNumRastreoSatelitalPhoto: async (file) => {
    const getImageBack = get().numRastreoSatelitalPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ numRastreoSatelitalPhoto: photoId }));
  },
  setAdhesivoPuertaPhoto: async (file) => {
    const getImageBack = get().adhesivoPuertaPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ adhesivoPuertaPhoto: photoId }));
  },
  setAdhesivoBisagraPhoto1: async (file) => {
    const getImageBack = get().adhesivoBisagraPhoto1;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ adhesivoBisagraPhoto1: photoId }));
  },
  setAdhesivoBisagraPhoto2: async (file) => {
    const getImageBack = get().adhesivoBisagraPhoto2;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ adhesivoBisagraPhoto2: photoId }));
  },
  setAdhesivoBisagraPhoto3: async (file) => {
    const getImageBack = get().adhesivoBisagraPhoto3;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ adhesivoBisagraPhoto3: photoId }));
  },
  setCableExporPhoto: async (file) => {
    const getImageBack = get().cableExporPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ cableExporPhoto: photoId }));
  },
  setBotellaExporPhoto: async (file) => {
    const getImageBack = get().botellaExporPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ botellaExporPhoto: photoId }));
  },
  setBotellaNavieraPhoto: async (file) => {
    const getImageBack = get().botellaNavieraPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ botellaNavieraPhoto: photoId }));
  },
  setVentoleraDerechaPhoto: async (file) => {
    const getImageBack = get().ventoleraDerechaPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ ventoleraDerechaPhoto: photoId }));
  },
  setVentoleraDerechaCheckPhoto: async (file) => {
    set(() => ({ ventoleraDerechaCheckPhoto: file }));
  },
  setVentoleraIzquierdaPhoto: async (file) => {
    const getImageBack = get().ventoleraIzquierdaPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ ventoleraIzquierdaPhoto: photoId! }));
  },
  setVentoleraIzquierdaCheckPhoto: async (file) => {
    set(() => ({ ventoleraIzquierdaCheckPhoto: file! }));
  },
  setPanelDerechoPhoto: async (file) => {
    const getImageBack = get().panelDerechoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ panelDerechoPhoto: photoId }));
  },
  setPanelIzquierdoPhoto: async (file) => {
    const getImageBack = get().panelIzquierdoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ panelIzquierdoPhoto: photoId }));
  },
  setPanelIzquierdoCheckPhoto: async (file) => {
    set(() => ({ panelIzquierdoCheckPhoto: file! }));
  },
  setPanelDerechoCheckPhoto: async (file) => {
    set(() => ({ panelDerechoCheckPhoto: file! }));
  },
  setPanelExteriorRePhoto1: async (file) => {
    const getImageBack = get().panelExteriorRePhoto1;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ panelExteriorRePhoto1: photoId }));
  },
  setPanelExteriorRePhoto2: async (file) => {
    const getImageBack = get().panelExteriorRePhoto2;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ panelExteriorRePhoto2: photoId }));
  },
  setPanelExteriorRePhoto3: async (file) => {
    const getImageBack = get().panelExteriorRePhoto3;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ panelExteriorRePhoto3: photoId }));
  },
  setInspectionContainerPhoto: async (file) => {
    const getImageBack = get().inspectionContainerPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = crypto.randomUUID();

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ inspectionContainerPhoto: photoId }));
  },
  setObservation: (observation) => set(() => ({ observation })),

  setSiglasCheckPhoto: (siglasCheckPhoto) => set(() => ({ siglasCheckPhoto })),
  setAdhesivoCheckPhoto: (adhesivoCheckPhoto) =>
    set(() => ({ adhesivoCheckPhoto })),
  setCableVerificadoraCheckPhoto: (cableVerificadoraCheckPhoto) =>
    set(() => ({ cableVerificadoraCheckPhoto })),
  setBotellaVerificadoraRastreoCheckPhoto: (
    botellaVerificadoraRastreoCheckPhoto
  ) => set(() => ({ botellaVerificadoraRastreoCheckPhoto })),
  setNumRastreoSatelitalCheckPhoto: (numRastreoSatelitalCheckPhoto) =>
    set(() => ({ numRastreoSatelitalCheckPhoto })),
  setAdhesivoPuertaCheckPhoto: (adhesivoPuertaCheckPhoto) =>
    set(() => ({ adhesivoPuertaCheckPhoto })),
  setAdhesivoBisagraCheckPhoto1: (adhesivoBisagraCheckPhoto1) =>
    set(() => ({ adhesivoBisagraCheckPhoto1 })),
  setAdhesivoBisagraCheckPhoto2: (adhesivoBisagraCheckPhoto2) =>
    set(() => ({ adhesivoBisagraCheckPhoto2 })),
  setAdhesivoBisagraCheckPhoto3: (adhesivoBisagraCheckPhoto3) =>
    set(() => ({ adhesivoBisagraCheckPhoto3 })),
  setCableExporCheckPhoto: (cableExporCheckPhoto) =>
    set(() => ({ cableExporCheckPhoto })),
  setBotellaExporCheckPhoto: (botellaExporCheckPhoto) =>
    set(() => ({ botellaExporCheckPhoto })),
  setBotellaNavieraCheckPhoto: (botellaNavieraCheckPhoto) =>
    set(() => ({ botellaNavieraCheckPhoto })),
  setDataCF: (ladata) =>
    set(() => ({
      siglasCheckPhoto: ladata.siglasCheckPhoto,
      adhesivoCheckPhoto: ladata.adhesivoCheckPhoto,
      cableVerificadoraCheckPhoto: ladata.cableVerificadoraCheckPhoto,
      botellaVerificadoraRastreoCheckPhoto:
        ladata.botellaVerificadoraRastreoCheckPhoto,
      numRastreoSatelitalCheckPhoto: ladata.numRastreoSatelitalCheckPhoto,
      adhesivoPuertaCheckPhoto: ladata.adhesivoPuertaCheckPhoto,
      adhesivoBisagraCheckPhoto1: ladata.adhesivoBisagraCheckPhoto1,
      adhesivoBisagraCheckPhoto2: ladata.adhesivoBisagraCheckPhoto2,
      adhesivoBisagraCheckPhoto3: ladata.adhesivoBisagraCheckPhoto3,
      cableExporCheckPhoto: ladata.cableExporCheckPhoto,
      botellaExporCheckPhoto: ladata.botellaExporCheckPhoto,
      botellaNavieraCheckPhoto: ladata.botellaNavieraCheckPhoto,
      panelExteriorCheckPhoto1: ladata.panelExteriorCheckPhoto1,
      panelExteriorCheckPhoto2: ladata.panelExteriorCheckPhoto2,
      panelExteriorCheckPhoto3: ladata.panelExteriorCheckPhoto3,
      ventoleraDerechaCheckPhoto: ladata.ventoleraDerechaCheckPhoto,
      ventoleraIzquierdaCheckPhoto: ladata.ventoleraIzquierdaCheckPhoto,
      panelIzquierdoCheckPhoto: ladata.panelIzquierdoCheckPhoto,
      panelDerechoCheckPhoto: ladata.panelDerechoCheckPhoto,
    })),
  getDataContainerCheckPoint: () => {
    const obj = {
      container: get().container,
      siglasPhoto: get().siglasPhoto,
      adhesivoPhoto: get().adhesivoPhoto,
      cableVerificadoraPhoto: get().cableVerificadoraPhoto,
      botellaVerificadoraRastreoPhoto: get().botellaVerificadoraRastreoPhoto,
      numRastreoSatelitalPhoto: get().numRastreoSatelitalPhoto,
      adhesivoPuertaPhoto: get().adhesivoPuertaPhoto,
      adhesivoBisagraPhoto1: get().adhesivoBisagraPhoto1,
      adhesivoBisagraPhoto2: get().adhesivoBisagraPhoto2,
      adhesivoBisagraPhoto3: get().adhesivoBisagraPhoto3,
      cableExporPhoto: get().cableExporPhoto,
      botellaExporPhoto: get().botellaExporPhoto,
      botellaNavieraPhoto: get().botellaNavieraPhoto,
      ventoleraDerechaPhoto: get().ventoleraDerechaPhoto,
      ventoleraIzquierdaPhoto: get().ventoleraIzquierdaPhoto,
      panelIzquierdoPhoto: get().panelIzquierdoPhoto,
      panelDerechoPhoto: get().panelDerechoPhoto,
      panelExteriorRePhoto1: get().panelExteriorRePhoto1,
      panelExteriorRePhoto2: get().panelExteriorRePhoto2,
      panelExteriorRePhoto3: get().panelExteriorRePhoto3,
      inspectionContainerPhoto: get().inspectionContainerPhoto,
      observation: get().observation,
    };

    return obj;
  },
  setDataContainerCheckPoint: (ladata) => {
    set(ladata);
    // get().getStatusCF();
  },
  getStatusCP: () => console.log("a"),
  getOnlyPhotos: () => {
    const obj = {
      siglasPhoto: get().siglasPhoto,
      adhesivoPhoto: get().adhesivoPhoto,
      cableVerificadoraPhoto: get().cableVerificadoraPhoto,
      botellaVerificadoraRastreoPhoto: get().botellaVerificadoraRastreoPhoto,
      numRastreoSatelitalPhoto: get().numRastreoSatelitalPhoto,
      adhesivoPuertaPhoto: get().adhesivoPuertaPhoto,
      adhesivoBisagraPhoto1: get().adhesivoBisagraPhoto1,
      adhesivoBisagraPhoto2: get().adhesivoBisagraPhoto2,
      adhesivoBisagraPhoto3: get().adhesivoBisagraPhoto3,
      cableExporPhoto: get().cableExporPhoto,
      botellaExporPhoto: get().botellaExporPhoto,
      botellaNavieraPhoto: get().botellaNavieraPhoto,
      ventoleraDerechaPhoto: get().ventoleraDerechaPhoto,
      ventoleraIzquierdaPhoto: get().ventoleraIzquierdaPhoto,
      panelIzquierdoPhoto: get().panelIzquierdoPhoto,
      panelDerechoPhoto: get().panelDerechoPhoto,
      panelExteriorRePhoto1: get().panelExteriorRePhoto1,
      panelExteriorRePhoto2: get().panelExteriorRePhoto2,
      panelExteriorRePhoto3: get().panelExteriorRePhoto3,
      inspectionContainerPhoto: get().inspectionContainerPhoto,
    };

    return obj;
  },
  onClear: async () => {
    const state = get();
    const keys = [
      state.siglasPhoto,
      state.adhesivoPhoto,
      state.cableVerificadoraPhoto,
      state.botellaVerificadoraRastreoPhoto,
      state.numRastreoSatelitalPhoto,
      state.adhesivoPuertaPhoto,
      state.adhesivoBisagraPhoto1,
      state.adhesivoBisagraPhoto2,
      state.adhesivoBisagraPhoto3,
      state.cableExporPhoto,
      state.botellaExporPhoto,
      state.botellaNavieraPhoto,
      state.ventoleraDerechaPhoto,
      state.ventoleraIzquierdaPhoto,
      state.panelIzquierdoPhoto,
      state.panelDerechoPhoto,
      state.panelExteriorRePhoto1,
      state.panelExteriorRePhoto2,
      state.panelExteriorRePhoto3,
      state.inspectionContainerPhoto,
    ];

    for (const key of keys) {
      if (
        key &&
        !key.startsWith("http://") &&
        !key.startsWith("https://") &&
        !key.startsWith("data:")
      ) {
        await removeImageBlob(key);
      }
    }

    set(() => ({
      id: null,
      container: "",
      statusCP: 0,

      siglasPhoto: "",
      adhesivoPhoto: "",
      cableVerificadoraPhoto: "",
      botellaVerificadoraRastreoPhoto: "",
      numRastreoSatelitalPhoto: "",
      adhesivoPuertaPhoto: "",
      adhesivoBisagraPhoto1: "",
      adhesivoBisagraPhoto2: "",
      adhesivoBisagraPhoto3: "",
      cableExporPhoto: "",
      botellaExporPhoto: "",
      botellaNavieraPhoto: "",
      ventoleraDerechaPhoto: "",
      ventoleraIzquierdaPhoto: "",
      panelIzquierdoPhoto: "",
      panelDerechoPhoto: "",
      panelExteriorRePhoto1: "",
      panelExteriorRePhoto2: "",
      panelExteriorRePhoto3: "",
      inspectionContainerPhoto: "",
      observation: "",

      siglasCheckPhoto: "",
      adhesivoCheckPhoto: "",
      cableVerificadoraCheckPhoto: "",
      botellaVerificadoraRastreoCheckPhoto: "",
      numRastreoSatelitalCheckPhoto: "",
      adhesivoPuertaCheckPhoto: "",
      adhesivoBisagraCheckPhoto1: "",
      adhesivoBisagraCheckPhoto2: "",
      adhesivoBisagraCheckPhoto3: "",
      cableExporCheckPhoto: "",
      botellaExporCheckPhoto: "",
      botellaNavieraCheckPhoto: "",
      ventoleraDerechaCheckPhoto: "",
      ventoleraIzquierdaCheckPhoto: "",
      panelIzquierdoCheckPhoto: "",
      panelDerechoCheckPhoto: "",
    }));
  },
});
